__turbopack_context__.v({
  "sportIcon": "sport-icon-module-sass-module__0cFs-a__sportIcon",
});
